import {
  AlertController,
  Nav,
  Platform,
  ToastController,
  ViewController,
} from "ionic-angular";
import { Component, ViewChild } from "@angular/core";

import { AppRepository } from "../repositories/app.repository";
import { AuthRepository } from "./../repositories/auth/auth.repository";
import { ConnectionProvider } from "../providers/connection/connection";
import { HttpErrorResponse } from "@angular/common/http";
import { Workbox } from "workbox-window";

@Component({
  templateUrl: "app.html",
})
export class MyApp {
  rootPage = "LoginPage";

  @ViewChild(Nav) nav: Nav;
  private pingPongTimeout: NodeJS.Timeout;

  constructor(
    public platform: Platform,
    public authRepository: AuthRepository,
    public appConfig: AppRepository,
    public connectionProvider: ConnectionProvider,
    public toastCtrl: ToastController,
    private alertCtrl: AlertController
  ) {
    this.platform.ready().then(() => {
      this.initApp();
    });
  }

  private initApp(): void {
    this.authRepository.me().subscribe();

    this.connectionProvider.watchOnlineStatus();

    this.authRepository.auth$.subscribe((res) => {

      if (window.location.href.indexOf('/activate/') === -1) {
        if (res.isAuthenticated) {
          this.nav.setRoot("OverviewPage");
          this.pingPong();
        } else {
          this.nav.setRoot("LoginPage");
        }
      }

      if (res.error) {
        this.toastCtrl
          .create({
            message: res.error.message,
            duration: 3000,
          })
          .present();
      }
    });

    this.nav.viewDidEnter.subscribe((view: ViewController) => {
      this.appConfig.setPage(view.id);
    });

    this.loadServiceWorker();
  }

  private loadServiceWorker() {
    if ("serviceWorker" in navigator) {
      const wb = new Workbox("service-worker.js");

      wb.addEventListener("installed", (event) => {
        if (event.isUpdate) {
          this.alertCtrl
            .create({
              title: "Nieuwe versie",
              message:
                "Er is een nieuwe versie van de applicatie beschikbaar! Klik op 'Bijwerken'.",
              buttons: [
                {
                  text: "Bijwerken.",
                  handler: () => {
                    window.location.reload();
                  },
                },
              ],
            })
            .present();
        }
      });

      wb.register();
    }
  }

  private pingPong() {
    this.appConfig.isOffline$.subscribe((offline) => {
      if (offline) {
        this.unRegisterPingPong();
      } else {
        this.registerPingPong();
      }
    });
  }

  private registerPingPong(): void {
    this.pingPongTimeout = setInterval(() => {
      this.authRepository.ping().subscribe(
        () => {},
        (err: HttpErrorResponse) => {
          if (err.status === 401) {
            this.unRegisterPingPong();
            this.alertCtrl
              .create({
                title: "Je wordt nu uitgelogd",
                subTitle:
                  "Het lijkt er op dat je ergens anders bent ingelogd met het zelfde account.",
                buttons: [
                  {
                    text: "OK",
                    handler: () => {
                      this.authRepository.logoutWithApiCall();
                    },
                  },
                ],
              })
              .present();
          }
        }
      );
    }, 10000); // 10 seconden
  }

  private unRegisterPingPong(): void {
    clearInterval(this.pingPongTimeout);
  }
}



// WEBPACK FOOTER //
// ./src/app/app.component.ts